import { CaratRight } from '@weee-fe/kunlunicon';
import { useCroppedImage } from '@weee-fe/module';
import useTranslation from 'next-translate/useTranslation';
import { buildUrlWithOrigin } from '@/utils/url';
import { isLatinoChannel } from '@/utils/common/latino-app';

const DescriptionModule = () => {
  const { t, lang } = useTranslation('referral');
  const { getCroppedUrl } = useCroppedImage();
  const basePath = process.env.CDN_COMMON_ASSETS_PATH || process.env.NEXT_PUBLIC_CDN_COMMON_ASSETS_PATH;
  const isLatino = isLatinoChannel();

  const description = [
    {
      image: getCroppedUrl(`${basePath}/referral/referral-img-1.png`, { devicePixelRatio: 3 }),
      title: t('referral_description_title_1'),
      description: t('referral_description_description_1'),
      buttonText: t('referral_description_button_text_1'),
      buttonLink: `/`
    },
    {
      image: getCroppedUrl(`${basePath}/referral/referral-img-2.png`, { devicePixelRatio: 3 }),
      title: t('referral_description_title_2'),
      description: t('referral_description_description_2'),
      buttonText: t('referral_description_button_text_2'),
      buttonLink: isLatino ? `/category/fruits` : `/category/trending?filter_sub_category=trending`
    },
    {
      image: getCroppedUrl(`${basePath}/referral/referral-img-3.png`, { devicePixelRatio: 3 }),
      title: t('referral_description_title_3'),
      description: t('referral_description_description_3'),
      buttonText: t('referral_description_button_text_3'),
      buttonLink: isLatino ? `/category/trending?filter_sub_category=trending` : `/category/freshbakery`
    },
    {
      image: getCroppedUrl(`${basePath}/referral/referral-img-4.png`, { devicePixelRatio: 3 }),
      title: t('referral_description_title_4'),
      description: t('referral_description_description_4'),
      buttonText: t('referral_description_button_text_4'),
      buttonLink: isLatino ? `/` : `/mkpl/waterfall`
    }
  ];
  return (
    <div className="w-full">
      {description.map((item, index) => (
        <div key={index} className="leading-[0]">
          <img src={item.image} alt={item.title} className="w-full h-auto" />
          <div className="p-5">
            <div className="w-11/12">
              <div className="enki-heading-xl text-primary-1">{item.title}</div>
              <div className="enki-heading-sm text-surface-100-fg-minor mt-3">{item.description}</div>
            </div>
            <a
              href={buildUrlWithOrigin(`/${lang}${item.buttonLink}`)}
              target="self"
              rel="noopener noreferrer"
              className="mt-[26px] inline-flex items-center h-9 pl-3 pr-2 rounded-full enki-body-sm-medium bg-surface-100-bg border border-solid border-link-base-1 text-link-base-1">
              <span>{item.buttonText}</span>
              <CaratRight fontSize={16} className="ml-1" color="text-link-base-1" />
            </a>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DescriptionModule;
